import { breakpoints, ComboBox } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import type { Option } from '../models';
import { css } from '@eti/styles';

interface RegionSelectProps {
  regions: { name: string; code: string }[];
  value: Option;
  onChange: (option: Option) => void;
}

const comboBoxStyles = css`
  @media (max-width: ${breakpoints._768}) {
    [role='listbox'] {
      max-height: 220px;
    }
  }
`;

const RegionSelect = ({ regions, value, onChange }: RegionSelectProps) => {
  const regionOptions = regions.map((region: { name: string; code: string }) => ({
    label: region.name,
    value: region.code,
  }));
  const { t } = useTranslation();
  const label = t('Settings.Region.Label');
  return (
    <ComboBox
      className={comboBoxStyles}
      data-testid="settings-region-input"
      label={label}
      name="regionSelect"
      noMatchLabel={t('Settings.NoMatchLabel')}
      onChange={onChange}
      options={regionOptions}
      placeholder={label}
      value={value}
    />
  );
};

export default RegionSelect;
